(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/carousel/assets/javascripts/react/hooks/use-drag.js') >= 0) return;  svs.modules.push('/components/lb-ui/carousel/assets/javascripts/react/hooks/use-drag.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useCallback = _React.useCallback,
  useEffect = _React.useEffect,
  useState = _React.useState,
  useRef = _React.useRef;
const _svs$components$lbUi$ = svs.components.lbUi.carousel.utils,
  DragState = _svs$components$lbUi$.DragState,
  MouseEvents = _svs$components$lbUi$.MouseEvents,
  TouchEvents = _svs$components$lbUi$.TouchEvents,
  supportsTouch = _svs$components$lbUi$.supportsTouch;
const useDrag = (ref, onStart, onMove, onEnd, onRelease) => {
  const _useState = useState(DragState.IDLE),
    _useState2 = _slicedToArray(_useState, 2),
    status = _useState2[0],
    setStatus = _useState2[1];
  const _useState3 = useState(() => supportsTouch()),
    _useState4 = _slicedToArray(_useState3, 2),
    touch = _useState4[0],
    setTouch = _useState4[1];
  const mouse = useRef({
    x: 0,
    y: 0
  });
  const enabled = useRef(true);
  const trackHandlers = useRef([]);
  let onStartCallback = onStart;
  let onMoveCallback = onMove;
  let onEndCallback = onEnd;
  let onReleaseCallback = onRelease;
  const DeviceEvent = touch ? TouchEvents : MouseEvents;
  const getLocationFromEvent = useCallback(e => ({
    x: touch ? e.changedTouches[0].clientX : e.pageX,
    y: touch ? e.changedTouches[0].clientY : e.pageY
  }), [touch]);
  const handleMove = useCallback(e => {
    var _onMoveCallback;
    if (enabled.current) {
      e.preventDefault();
    }
    const p = getLocationFromEvent(e);
    const dist = {
      x: p.x - mouse.current.x,
      y: p.y - mouse.current.y
    };
    (_onMoveCallback = onMoveCallback) === null || _onMoveCallback === void 0 || _onMoveCallback(dist);
  }, [getLocationFromEvent, onMoveCallback]);
  const handleEnd = useCallback(e => {
    var _onEndCallback;
    if (enabled.current) {
      e.preventDefault();
    }
    const p = getLocationFromEvent(e);
    const dist = {
      x: p.x - mouse.current.x,
      y: p.y - mouse.current.y
    };
    window.removeEventListener(TouchEvents.MOVE, handleMove);
    window.removeEventListener(MouseEvents.MOVE, handleMove);
    window.removeEventListener(TouchEvents.STOP, handleEnd);
    window.removeEventListener(MouseEvents.STOP, handleEnd);
    setStatus(DragState.END);
    requestAnimationFrame(() => setStatus(DragState.IDLE));
    (_onEndCallback = onEndCallback) === null || _onEndCallback === void 0 || _onEndCallback(dist);
  }, [getLocationFromEvent, handleMove, onEndCallback]);
  const handleStart = useCallback(e => {
    var _onStartCallback;
    if (!enabled.current) {
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    if (e.target.closest('button') || e.target.closest('a')) {
      return;
    }
    mouse.current = getLocationFromEvent(e);
    window.removeEventListener(DeviceEvent.MOVE, handleMove);
    window.removeEventListener(DeviceEvent.STOP, handleEnd);
    window.addEventListener(DeviceEvent.MOVE, handleMove, {
      passive: false
    });
    window.addEventListener(DeviceEvent.STOP, handleEnd, {
      passive: false
    });
    setStatus(DragState.START);
    requestAnimationFrame(() => setStatus(DragState.DRAGGING));
    (_onStartCallback = onStartCallback) === null || _onStartCallback === void 0 || _onStartCallback(mouse.current);
  }, [DeviceEvent, getLocationFromEvent, handleEnd, handleMove, onStartCallback]);
  const enable = () => enabled.current = true;
  const disable = () => enabled.current = false;
  const isEnabled = () => enabled.current;
  const release = () => {
    var _onReleaseCallback;
    window.removeEventListener(TouchEvents.MOVE, handleMove);
    window.removeEventListener(MouseEvents.MOVE, handleMove);
    window.removeEventListener(TouchEvents.STOP, handleEnd);
    window.removeEventListener(MouseEvents.STOP, handleEnd);
    (_onReleaseCallback = onReleaseCallback) === null || _onReleaseCallback === void 0 || _onReleaseCallback();
  };
  const registerCallbacks = _ref => {
    let onStart = _ref.onStart,
      onMove = _ref.onMove,
      onEnd = _ref.onEnd,
      onRelease = _ref.onRelease;
    onStartCallback = onStart || onStartCallback;
    onMoveCallback = onMove || onMoveCallback;
    onEndCallback = onEnd || onEndCallback;
    onReleaseCallback = onRelease || onReleaseCallback;
  };
  useEffect(() => {
    const handleResize = () => {
      const t = supportsTouch();
      if (touch !== t) {
        setTouch(t);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [touch]);
  useEffect(() => {
    const element = (ref === null || ref === void 0 ? void 0 : ref.current) || ref;
    if (element && element instanceof Element) {
      trackHandlers.current.push(DeviceEvent.START);
      element.addEventListener(DeviceEvent.START, handleStart, {
        passive: false
      });
    }
    const handlers = trackHandlers.current;
    return () => {
      while (handlers.length) {
        element === null || element === void 0 || element.removeEventListener(handlers.pop(), handleStart);
      }
    };
  }, [DeviceEvent.START, handleStart, ref]);
  return {
    enable,
    disable,
    isEnabled,
    release,
    registerCallbacks,
    status
  };
};
setGlobal('svs.components.carousel.hooks', {
  DragState,
  useDrag,
  supportsTouch
});

 })(window);